var React = require('react');

function BgHead (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M688 1028C688 366 931 416 931 -4H-118V1028H688Z","fill":"#FEAC00","key":0}),React.createElement("path",{"d":"M-26.9999 1098C328.2 1239.6 685.5 1166.5 688 1028H-51C-51 1076 -26.9999 1098 -26.9999 1098Z","fill":"#FEAC00","key":1})]);
}

BgHead.defaultProps = {"width":"931","height":"1175","viewBox":"0 0 931 1175","fill":"none"};

module.exports = BgHead;

BgHead.default = BgHead;
